import {IExploreMoreContainer} from '@wearesection/bandai-react-components/organisms/ExploreMoreContainer';
import React from 'react';
import {ComponentPropsAdapter} from '../../types';
import {IMG_NO_PATCH_NOTES, PLACEHOLDER_IMG} from '~/constants';
import {Box} from '@mui/material';
import {News} from '~/graphql/types';
// import moment from 'moment';
import * as Types from '../../../../graphql/types';
import RenderNextImage from '../../atoms/render-next-image';
import {
  GetRouter,
  handleCovertTagPrimary,
  handleReturnColorTag,
  handleTranslateNews,
} from '~/utils';
import {handleReturnDateForLocal} from '../scrolling-thumbnail-card/scrolling-thumbnail-card';
import dynamic from 'next/dynamic';
const ExploreMoreContainer = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/ExploreMoreContainer'),
  {ssr: false}
);
type IExploreMoreContainerExt = IExploreMoreContainer &
  News & {
    listLatestNews: {
      items: News[];
    };
    listPatchNotes: {
      items: News[];
    };
  } & any;
const handleDataListLatestNews = (data: IExploreMoreContainerExt) => {
  const featuredNewsCard: News = data?.listLatestNews?.items?.[0];
  const popularNewsCard: News[] = [];
  data?.listLatestNews?.items?.filter((item: News, index: number) => {
    index > 0 && popularNewsCard.push(item);
  });

  if (data?.listLatestNews?.items?.length === 0) {
    return null;
  } else
    return {
      featuredNewsCard: featuredNewsCard,
      popularNewsCard: popularNewsCard,
    };
};

const handleDataListPatchNotes = (data: IExploreMoreContainerExt) => {
  const featuredNewsCard: News = data?.listPatchNotes?.items?.[0];
  const popularNewsCard: News[] = [];
  data?.listPatchNotes?.items?.filter((item: News, index: number) => {
    index > 0 && popularNewsCard.push(item);
  });

  if (data?.listPatchNotes?.items.length === 0) {
    return null;
  } else
    return {
      featuredNewsCard,
      popularNewsCard,
    };
};

// game detail
const adapterGamesListing: ComponentPropsAdapter<
  IExploreMoreContainerExt,
  IExploreMoreContainer
> = data => {
  const dataListLatestNews = handleDataListLatestNews(data) ?? null;

  const dataListPatchNotes = handleDataListPatchNotes(data) ?? null;
  const {locale} = GetRouter();
  const popularNewsCard = dataListPatchNotes?.popularNewsCard ?? [];
  const dataTranslation = data?.dataTranslation || {};
  const title = data?.detailGame?.title ?? '';
  const listTags = data?.listTags ?? [];
  return {
    title: data?.title ?? dataTranslation['game-detailed-explore-more-patch-notes'],
    blank: {
      image: IMG_NO_PATCH_NOTES ?? PLACEHOLDER_IMG,
      'title-1': dataTranslation['game-detailed-explore-more-lastest-news-empty'],
      'title-2': dataTranslation['game-detailed-explore-more-patch-notes-empty'],
      'description-1': dataTranslation['game-detailed-explore-more-thanks'],
      'description-2': dataTranslation['game-detailed-explore-more-thanks'],
    },
    listTabs: [
      {
        id: 1,
        label: dataTranslation['game-detailed-explore-more-lastest-news'],
      },
      {
        id: 2,
        label: dataTranslation['game-detailed-explore-more-patch-notes'],
      },
    ],
    listThumbnail: [
      dataListLatestNews !== null
        ? {
            id: 1,
            featuredNewsCard: {
              title: dataListLatestNews?.featuredNewsCard?.title ?? '',
              description: dataListLatestNews?.featuredNewsCard?.shortDescription ?? '',
              linkHref: `/${locale}/news/${dataListLatestNews?.featuredNewsCard?.slug}`,
              mainImage:
                dataListLatestNews?.featuredNewsCard?.mainImage?.media?.url ?? PLACEHOLDER_IMG,
              tags: [
                handleReturnColorTag(
                  (dataListLatestNews?.featuredNewsCard as any)?.customTags,
                  listTags || [],
                  (dataListLatestNews?.featuredNewsCard as any)?.game?.releaseDate,
                  locale
                ),
              ],
              hrefTag: `/${locale}/news`,
              mainImageNext: (
                <RenderNextImage
                  src={
                    dataListLatestNews?.featuredNewsCard?.mainImage?.media?.url ?? PLACEHOLDER_IMG
                  }
                  width={535}
                  height={300}
                  alt={dataListLatestNews?.featuredNewsCard?.mainImage?.alt ?? ''}
                />
              ),
              date: handleReturnDateForLocal(
                locale || '',
                `${dataListLatestNews?.featuredNewsCard?.publishDate}`.substring(0, 10)
              ),
              variant: 'vertical',
            },
            popularNewsCard:
              dataListLatestNews?.popularNewsCard?.map((item: News) => {
                return {
                  title: item?.title ?? '',
                  mainImage: item?.mainImage?.media?.url ?? '',
                  linkHref: `/${locale}/news/${item?.slug}`,
                  tags: [
                    handleReturnColorTag(
                      (item as any)?.customTags,
                      listTags || [],
                      item?.game?.releaseDate,
                      locale
                    ),
                  ],
                  // tags: [
                  //   {
                  //     title: handleTranslateNews((item as any)?.customTags, dataTranslation),
                  //     color:
                  //       listTags?.find(
                  //         (e: any) =>
                  //           e.name?.toUpperCase() ===
                  //           ((item as any)?.customTags as string)?.toUpperCase()
                  //       )?.backgroundColor ?? '',
                  //   },
                  // ],
                  date: handleReturnDateForLocal(
                    locale || '',
                    `${item?.publishDate}`.substring(0, 10)
                  ),
                  hrefTag: `/${locale}/news`,
                  mainImageNext: (
                    <RenderNextImage
                      src={item?.mainImage?.media?.url ?? PLACEHOLDER_IMG}
                      width={190}
                      height={133}
                      alt={item?.title ?? ''}
                    />
                  ),
                };
              }) || [],
            viewMore: {
              title: dataTranslation['game-detailed-explore-more-see-all-news'] ?? '',
              href: `/${locale}/news?title=${title}&t=1`,
              target: '_blank',
            },
          }
        : {},

      dataListPatchNotes !== null
        ? {
            id: 2,
            featuredNewsCard: {
              title: dataListPatchNotes?.featuredNewsCard?.title ?? '',
              description: dataListPatchNotes?.featuredNewsCard?.shortDescription ?? '',
              linkHref: `/${locale}/news/${dataListPatchNotes?.featuredNewsCard?.slug}`,
              hrefTag: `/${locale}/news`,
              mainImage:
                dataListPatchNotes?.featuredNewsCard?.mainImage?.media?.url ?? PLACEHOLDER_IMG,
              tags: [
                {
                  title: handleCovertTagPrimary(
                    (
                      (dataListPatchNotes?.featuredNewsCard as any)?.customTags as string
                    )?.toUpperCase(),
                    (dataListPatchNotes?.featuredNewsCard as any)?.game?.releaseDate ?? '',
                    locale as string
                  ),

                  color: listTags?.find(
                    (e: any) =>
                      e?.name?.toLocaleLowerCase() ===
                      (handleCovertTagPrimary(
                        (
                          (dataListPatchNotes?.featuredNewsCard as any)?.customTags as string
                        )?.toUpperCase(),
                        (dataListPatchNotes?.featuredNewsCard as any)?.game?.releaseDate ?? '',
                        locale as string
                      )?.toLocaleLowerCase() as string)
                  )?.backgroundColor,
                },
              ],
              date: handleReturnDateForLocal(
                locale || '',
                `${dataListPatchNotes?.featuredNewsCard?.publishDate}`.substring(0, 10)
              ),
              variant: 'vertical',
            },
            popularNewsCard:
              dataListPatchNotes?.popularNewsCard?.map((item: any) => {
                return {
                  title: item?.title ?? '',
                  mainImage: item?.mainImage?.media?.url ?? '',
                  linkHref: `/${locale}/news/${item?.slug}`,
                  tags: [
                    handleReturnColorTag(
                      item?.customTags,
                      listTags || [],
                      item?.game?.releaseDate,
                      locale
                    ),
                  ],
                  date: handleReturnDateForLocal(
                    locale || '',
                    `${item?.publishDate}`.substring(0, 10)
                  ),
                  hrefTag: `/${locale}/news`,
                  mainImageNext: (
                    <RenderNextImage
                      src={item?.mainImage?.media?.url ?? PLACEHOLDER_IMG}
                      width={190}
                      height={133}
                      alt={item?.title ?? ''}
                    />
                  ),
                };
              }) || [],
            viewMore: {
              title: dataTranslation['game-detailed-explore-more-see-all-patch-notes'],
              href:
                dataListPatchNotes?.featuredNewsCard?.title &&
                dataListPatchNotes?.featuredNewsCard?.slug
                  ? `/${locale}/news?title=${title}&t=2`
                  : `/${locale}/${data?.seeAllSlug ?? 'news'}`,
              target: '_blank',
            },
          }
        : {},
    ],
  };
};

// home page
const adapterHomePage = (data: Types.GamesListing | any) => {
  const {locale} = GetRouter();
  const valueListItem = data?.listItemCollection;
  const dataTranslation = data?.dataTranslation || {};
  const listTags = data?.listTags ?? [];
  return {
    title: data?.title || '',
    blank: {
      image:
        'https://images.ctfassets.net/hnoi7ctzfs57/6PWKWGwxdxGmygGehkURsT/96822ad3ddc440402bd8238bf513d279/Group_123603.png',
      'title-1': dataTranslation['game-detailed-explore-more-lastest-news'],
      'description-1': dataTranslation['game-detailed-explore-more-thanks'],
    },
    listThumbnail: [
      {
        id: 1,
        viewMore: {
          title: data?.seeAllText ?? '',
          href: `/${locale}${data?.seeAllSlug ?? '/news'}`,
          target: '_parent',
        },
        featuredNewsCard: {
          title: valueListItem?.[0]?.title || valueListItem?.[0]?.game?.title || '',
          description:
            valueListItem?.[0]?.shortDescription ||
            valueListItem?.[0]?.game?.overviewDescription ||
            '',
          linkHref: `/${locale}/news/${valueListItem?.[0]?.slug ?? valueListItem?.[0]?.game?.slug}`,
          mainImage: valueListItem?.[0]?.mainImage?.media?.url || PLACEHOLDER_IMG,
          tags: [
            handleReturnColorTag(
              valueListItem?.[0]?.customTags,
              listTags || [],
              valueListItem?.[0]?.game?.releaseDate,
              locale
            ),
          ],
          // tags: [
          //   {
          //     title: handleTranslateNews(valueListItem?.[0]?.customTags, dataTranslation),
          //     color:
          //       listTags?.find(
          //         (e: any) =>
          //           e.name?.toUpperCase() ===
          //           (valueListItem?.[0]?.customTags as string)?.toUpperCase()
          //       )?.backgroundColor ?? '',
          //   },
          // ],
          hrefTag: `/${locale}/news`,
          mainImageNext: (
            <RenderNextImage
              src={valueListItem?.[0]?.mainImage?.media?.url || PLACEHOLDER_IMG}
              width={535}
              height={300}
              alt={valueListItem?.[0]?.title || ''}
            />
          ),
          date: handleReturnDateForLocal(locale || '', valueListItem?.[0]?.publishDate),
          variant: 'vertical',
        },
        popularNewsCard: valueListItem
          ?.map((card: any) => {
            return {
              title: card?.title || card?.game?.title || '',
              linkHref: `/${locale}/news/${card?.slug}`,
              mainImage: card?.mainImage?.media?.url || PLACEHOLDER_IMG,
              date: handleReturnDateForLocal(locale || '', `${card?.publishDate}`.substring(0, 10)),
              tags: [
                handleReturnColorTag(
                  card?.customTags,
                  listTags || [],
                  card?.game?.releaseDate,
                  locale
                ),
              ],
              // tags: [
              //   {
              //     title: handleTranslateNews(card?.customTags, dataTranslation),
              //     color:
              //       listTags?.find(
              //         (e: any) =>
              //           e.name?.toUpperCase() === (card?.customTags as string)?.toUpperCase()
              //       )?.backgroundColor ?? '',
              //   },
              // ],
              hrefTag: `/${locale}/news`,
              mainImageNext: (
                <RenderNextImage
                  src={card?.mainImage?.media?.url ?? PLACEHOLDER_IMG}
                  width={190}
                  height={133}
                  alt={card?.title ?? ''}
                />
              ),
            };
          })
          ?.slice(1),
      },
    ],
  };
};

const handleTypeName = (props: any) => {
  const typeName: any = {
    HomePageGamesListing: adapterHomePage(props),
    GamesListing: adapterGamesListing(props),
  };
  return typeName[props.__typename] || typeName['GamesListing'];
};

const ExploreMoreContainerOrganisms: React.FC<IExploreMoreContainerExt> = (props: any) => {
  const ComponentProps = handleTypeName(props);
  const {pathname, locale} = GetRouter();

  const localeLowCase = (locale as string)?.toLocaleLowerCase();
  const PADDING_COMPONENT: any = {
    '/': {
      paddingTop: {
        xs: props?.removePadding ? '0px' : '72px',
        lg: props?.removePadding
          ? '0px'
          : localeLowCase === 'hk-sc' ||
            localeLowCase === 'hk-tc' ||
            localeLowCase === 'tw-sc' ||
            localeLowCase === 'tw-tc' ||
            localeLowCase === 'ko-kr'
          ? '80px'
          : '40px',
      },
      paddingBottom: {
        xs: '72px',
        lg: '40px',
      },
    },
    '/games/[slug]': {
      paddingTop: {
        xs: '72px',
        lg: '40px',
      },
      paddingBottom: {
        xs: '72px',
        lg: '40px',
      },
    },
  };
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? PADDING_COMPONENT['/']}>
      <ExploreMoreContainer {...ComponentProps} id={props?.id || ''} />
    </Box>
  );
};

export default ExploreMoreContainerOrganisms;
